<template>
  <div>
    <v-row>
      <v-col cols="12 py-0">
        <v-card>
          <v-row v-if="productIsVisible">
            <v-col cols="6">
              <span class="productAlert text-no-wrap">
                <b> * {{ errormsgs }}</b>
              </span>
            </v-col>
          </v-row>

          <v-card-title>
            <v-row style="padding: 0">
              <v-col cols="auto" class="mr-auto">Products</v-col>
              <!-- <v-col cols="4" style="padding:0"></v-col> -->
              <v-col cols="auto" class="pa-2">
                <v-btn
                  depressed
                  style="
                    width: 105px;
                    height: 29px !important;
                    background: rgb(255 19 40);
                    color: white;
                    font-size: 12px !important;
                  "
                  class="text-white text-right btn_medium submitbutton"
                  @click="clearAll"
                  v-if="StoredProducts.length != 1"
                >
                  <v-icon style="font-size: 16px !important"
                    >mdi-delete
                  </v-icon>
                  Clear All</v-btn
                >
              </v-col>
            </v-row>
          </v-card-title>
          <v-container fluid>
            <!-- {{ StoredProducts }} -->

            <v-row>
              <v-col cols="12">
                <tr
                  class="ma-5"
                  v-for="(item, index) in StoredProducts"
                  :key="index"
                >
                  <v-row
                    :style="[
                      item.available_Stocks == 0 && item.validateUnit
                        ? { background: '#ff6f6a' }
                        : { background: 'white' },
                    ]"
                  >
                    <v-col
                      cols="12"
                      lg="3"
                      md="3"
                      sm="6"
                      xs="6"
                      class=" "
                      style="text-align: center"
                    >
                      <v-autocomplete
                        v-if="
                          (item.ProductVisible || StoredProducts.length == 1) &&
                          !saleQuotation
                        "
                        :value="item.productid"
                        :items="products"
                        hide-details="auto"
                        item-text="name"
                        class="ma-2"
                        item-value="id"
                        label="Choose product"
                        outlined
                        dense
                        @change="AssignListToProduct($event, index, item)"
                        :search-input.sync="searchProduct"
                        :loading="productGetLoading"
                        :error-messages="errors"
                        @input="onSelectProduct"
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ item.name }}</div>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        v-else
                        :value="item.selectedProdct.name"
                        hide-details="auto"
                        class="ma-2"
                        label="Product"
                        outlined
                        dense
                        readonly
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" lg="2" md="2" sm="6">
                      <v-select
                        :value="item.selectedUnit.id"
                        :items="item.units"
                        hide-details="auto"
                        item-text="name"
                        class="ma-2"
                        item-value="id"
                        label="Units"
                        outlined
                        dense
                        :error-messages="errors"
                        :disabled="checkDisable(item.selectedProdct)"
                      >
                        <template v-slot:item="{ item, attrs, on }">
                          <v-list-item
                            v-bind="attrs"
                            v-on="on"
                            @click="updateUnitPrice($event, index, item)"
                          >
                            <v-list-item-title
                              :id="attrs['aria-labelledby']"
                              v-text="item.name"
                            ></v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" xs="12" lg="2" md="2" sm="6">
                      <v-select
                        :value="item.selectedBatch.id"
                        :items="item.batches"
                        hide-details="auto"
                        item-text="batch"
                        item-value="id"
                        class="ma-2"
                        label="Batch"
                        outlined
                        dense
                        :error-messages="errors"
                        :disabled="checkDisable(item.selectedProdct)"
                      >
                        <template v-slot:item="{ item, attrs, on }">
                          <v-list-item
                            v-bind="attrs"
                            v-on="on"
                            @click="updateUnitDetails($event, index, item)"
                          >
                            <v-list-item-title
                              :id="attrs['aria-labelledby']"
                              v-text="item.batch"
                            ></v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" xs="12" lg="2" md="2" sm="3">
                      <v-text-field
                        :value="item.amount"
                        hide-details="auto"
                        class="ma-2"
                        label="Price"
                        outlined
                        min="0"
                        :disabled="saleQuotation"
                        type="number"
                        oninput="validity.valid||(value='');"
                        readonly
                        dense
                        @input="updateprice($event, index, item)"
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      lg="1"
                      md="1"
                      sm="3"
                      xs="12"
                      :style="[
                        item.available_Stocks < item.quantity &&
                        item.validateUnit
                          ? { background: '#ff6f6a' }
                          : { background: 'white' },
                      ]"
                    >
                      <v-text-field
                        :value="item.quantity"
                        hide-details="auto"
                        class="ma-2"
                        label="Quantity"
                        :disabled="saleQuotation"
                        min="0"
                        type="number"
                        :max="item.available_Stocks"
                        outlined
                        @input="updateProductQuantity($event, index, item)"
                        dense
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="1" lg="1" md="1" sm="3">
                      <v-text-field
                        :value="item.discount"
                        hide-details="auto"
                        class="ma-2"
                        @input="updateProductDiscount($event, index, item)"
                        label="Discount"
                        min="0"
                        type="number"
                        :disabled="saleQuotation"
                        outlined
                        dense
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="auto"
                      class="ml-auto mt-4"
                      style="text-align: left"
                    >
                      <span class="amountcash">
                        <b>
                          {{
                            (item.amount * item.quantity -
                              item.discount * item.quantity)
                              | formatCurrency
                          }}</b
                        >
                      </span>
                    </v-col>
                    <v-col
                      cols="auto"
                      class="mt-1"
                      style="text-align: center; display: flex; padding: 0px"
                    >
                      <v-icon
                        style="color: green; font-size: 20px !important"
                        class="icon_large"
                        v-bind="attrs"
                        @click="UpdateProductStore(item)"
                        v-on="on"
                        >mdi-plus-box</v-icon
                      >
                      <!-- {{StoredProducts.length}} -->
                      <v-icon
                        v-if="index != 0 || StoredProducts.length > 1"
                        style="color: red; font-size: 20px !important"
                        class="icon_large ml-2"
                        v-bind="attrs"
                        @click="removeProduct(item, index)"
                        v-on="on"
                        >mdi-delete</v-icon
                      >
                    </v-col>
                  </v-row>
                </tr>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </div>
</template>
<script>
import { Product } from '../../models/Product';
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';

import { BillModel, BillDecorator } from '@/models/BillModel';

export default {
  data: () => ({
    searchProduct: null,
    isLoading: null,

    productGetLoading: false,
    stockValidationError: false,

    products: [],
    SingleProduct: [],
  }),
  props: {
    shopId: {
      type: Number,
      default: 1,
    },
    productIsVisible: {
      type: Boolean,
      default: false,
    },
    errormsgs: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['StoredProducts']),
    ...mapState(['shopIdFilter']),
    ...mapState(['saleQuotation']),
    ...mapGetters(['GetTotalAmount']),
  },
  mounted: function () {
    this.getProductsByQuery('');
    this.SetTotalAmount(this.GetTotalAmount);
  },
  methods: {
    checkDisable(item) {
      return item.id ? false : true;
    },
    SetTotalAmount(newValue) {
      this.$store.commit('UPDATE_TOTAL_AMOUNT', {
        amount: newValue,
      });
    },
    // Get Single Product Details
    GetProduct(Id) {
      this.$store
        .dispatch('product/GetProductByIdShop', { Id: Id, shop: this.shopId })
        .then((res) => {
          this.SingleProduct = res.data.data;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },

    // Remove Product in List
    clearAll() {
      this.$store.commit('REMOVE_ALL');
    },

    // Remove Product in List
    removeProduct(item, index) {
      this.$store.commit('REMOVE_PRODUCT', {
        index: index,
      });
    },

    // Update Discount Values To List
    async updateProductDiscount(newValue, index, item) {
      this.$store.commit('UPDATE_PRODUCT_DISCOUNT', {
        discount: newValue,
        index: index,
      });
    },
    // Update Quantity Values To List
    async updateProductQuantity(newValue, index, item) {
      // if (newValue < item.available_Stocks) {
      this.productIsVisible = false;
      this.$store.commit('UPDATE_PRODUCT_QUANTITY', {
        quantity: newValue,
        index: index,
      });
      // }
      if (newValue > item.available_Stocks) {
        this.productIsVisible = true;
        this.errormsgs =
          'in this selected shop you have only ' +
          item.available_Stocks +
          ' stock in ' +
          item.selectedProdct.name +
          '  Product';
      }
    },

    // Assaign Price Values To List
    async updateprice(newValue, index, item) {
      this.$store.dispatch('changeProductprice', {
        index: index,
        amount: newValue,
      });
    },
    // Assaign Values To List
    async UpdateProductStore(newValue, index, item) {
      this.$store.dispatch('AddNewProductToSales', {
        index: index,
      });
    },
    // Assaign Values To List
    async AssignListToProduct(newValue, index, item) {
      await this.GetProduct(newValue);

      setTimeout(() => {
        this.$store.dispatch('AddProductToSales', {
          datas: new BillDecorator(this.SingleProduct).toBill(),
          index: index,
        });
      }, 400);
    },

    // Assaign Values To List
    updateUnitDetails(newValue, index, item) {
      setTimeout(() => {
        this.$store.dispatch('AddUnitPerticularProduct', {
          item: item,
          index: index,
        });
      }, 400);
    },
    // Assaign Values To List
    updateUnitPrice(newValue, index, item) {
      setTimeout(() => {
        this.$store.dispatch('AddUnitPerticularProductPrices', {
          item: item,
          index: index,
        });
      }, 400);
    },

    // Search Product
    getProductsByQuery(query = '') {
      this.productGetLoading = true;
      this.$store
        .dispatch('product/GetProductShops', {
          query: query,
          status: 'active',
          shop: this.shopId,
        })
        .then((res) => {
          this.products = res.map((u, i, arr) => {
            u.index = i + 1;
            return new Product().toViewModel(u);
          });
          this.isLoading = false;
          this.productGetLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.productGetLoading = false;
          this.messages = err.data.title;
        });
    },
  },

  watch: {
    shopId: function () {
      this.clearAll();
      this.getProductsByQuery('');
    },

    searchProduct(value) {
      if (!value) {
        this.getProductsByQuery('');
      }

      this.getProductsByQuery(value);
    },
  },
};
</script>

<style scoped>
.productAlert {
  color: red;
  font-size: 14px;
}
</style>
